import { Structure } from 'Editor/modals/EquationsModal/ToolbarElements';
import { useEquationsContext } from 'Editor/modals/EquationsModal/EquationsContext';

import { useEffect, useRef } from 'react';
import { Logger } from '_common/services';
import { MMLHelper } from '_common/utils/MMLHelper';

type GridItemProps = {
  element: Structure['elements'][number];
  testId: string;
};

const GridItem = ({ element, testId }: GridItemProps) => {
  const { onElementInsertion } = useEquationsContext();
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.innerHTML = '';

      if (element) {
        try {
          MMLHelper.appendMMLToElement(element.mathml, ref.current);
        } catch (error) {
          Logger.error(error);
        }
      }
    }
  }, [element]);

  const onClick = () => {
    onElementInsertion(element);
  };
  return (
    <div
      className="bg-neutral-5 flex cursor-pointer items-center justify-center rounded-lg shadow-[inset_0_0_0_1px_var(--colors-neutral-20)] hover:shadow-[0_4px_6px_0_rgba(0,0,0,0.2),inset_0_0_0_1px_var(--colors-neutral-20)]"
      onClick={onClick}
      style={{
        gridArea: `span ${element.repX || 1} / span ${element.repY || 1}`,
      }}
      ref={ref}
      data-testid={testId}
    />
  );
};

export default GridItem;
